import React from "react"
import styled from "styled-components"
import { getColor } from "../../../../components/Color"
import { media } from "../../../../components/mediaStyles"
import { Modal as AntdModal } from "antd"
import SignatureCanvas from "./SignatureCanvas"

const SignatureInput = styled.div`
  height: 100px;
  width: 100%;
  font-family: GT America, sans-serif;
  border: 1px solid ${getColor("primary", 0.3)};
  border-radius: 4px;
  padding-right: 30px !important;
  font-size: 16px !important;

  &:focus,
  &:hover {
    border-color: ${getColor("primary", 0.6)} !important;
    cursor: pointer;
  }
`

const AreaWrapper = styled.div`
  position: relative;

  ${media.tablet`
    max-width: 400px;
  `}
`

const Prefix = styled.div`
  position: absolute;
  top: -5px;
  right: 10px;
  z-index: 1;
`

const Suffix = styled.div`
  position: absolute;
  bottom: 0px;
  right: 10px;
  z-index: 1;
`

const Placeholder = styled.div`
  pointer-events: none;
  text-align: center;
  font-size: 18px;
  font-family: GT America, sans-serif;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${getColor("primary", 0.6)};
`

const Modal = styled(AntdModal)`
  touch-action: none;
`

const SigantureImage = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
  padding-right: 30px;
  padding-left: 10px;
  img {
    margin: 0 !important;
    max-width: 100%;
  }
`

export default class Signature extends React.Component {
  state = {
    showSignatureInput: false,
    signature: null,
    visible: true,
  }

  render() {
    return (
      <AreaWrapper onClick={() => this.setState({ showSignatureInput: true })}>
        <Prefix>{this.props.prefix}</Prefix>
        <SignatureInput />
        <Modal
          visible={this.state.showSignatureInput}
          footer={null}
          onOk={event => {
            event.stopPropagation()
            this.setState({ showSignatureInput: false })
          }}
          onCancel={event => {
            event.stopPropagation()
            this.setState({ showSignatureInput: false })
          }}
        >
          <SignatureCanvas
            // onSignatureChange={signature => this.setState({ signature })}
            onSignatureChange={this.props.onChange}
            onClose={event => {
              event.stopPropagation()
              this.setState({ showSignatureInput: false })
            }}
            signature={this.props.value}
          />
        </Modal>
        {this.props.value ? (
          <SigantureImage>
            <img src={this.props.value} alt="Ihre Unterschrift" />
          </SigantureImage>
        ) : (
          <Placeholder>Zum Unterschreiben klicken</Placeholder>
        )}
        <Suffix>{this.props.suffix}</Suffix>
      </AreaWrapper>
    )
  }
}
